var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6666 5.21903V13.3334H7.33327V5.21903L3.75726 8.79501L2.81445 7.85221L7.99993 2.66675L13.1853 7.85221L12.2425 8.79501L8.6666 5.21903Z",
    fill: "#EF3232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority);
export default __webpack_public_path__ + "static/media/priority.d61848ff853137baf5a415ab9dc15db0.svg";
export { ForwardRef as ReactComponent };